export const SNACK_DEFAULT_TIMEOUT = 5000;
